import React from 'react';

// CB:BEGIN email-preview-start-date-set
const EmailStartDateSet: React.FC = () => {
  const date = 'Aug 15, 2025';
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '600px', margin: '0 auto', padding: 20 }}>
      <div style={{ background: '#059669', padding: 20, borderRadius: 8, marginBottom: 20, textAlign: 'center' }}>
        <h2 style={{ color: 'white', margin: 0 }}>📅 Start Date Confirmed</h2>
      </div>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        Excellent! Your roofing project start date has been confirmed and scheduled.
      </p>
      <div style={{ background: '#ecfdf5', padding: 15, borderRadius: 6, margin: '20px 0', borderLeft: '4px solid #059669' }}>
        <p style={{ fontSize: 16, fontWeight: 600, margin: 0, color: '#065f46' }}>
          <strong>Project Start Date:</strong> {date}
        </p>
      </div>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}><strong>What to expect:</strong></p>
      <ul style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        <li>Contractor team will arrive on the scheduled date</li>
        <li>Work will begin according to the agreed timeline</li>
        <li>You'll receive regular progress updates</li>
        <li>We'll send you a reminder 24 hours before start</li>
      </ul>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        Please ensure your property is ready and accessible for the contractor team on the scheduled date.
      </p>
      <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', margin: '30px 0' }} />
      <p style={{ fontSize: 12, color: '#6b7280', textAlign: 'center' }}>
        From: CoreBids Notifications &lt;notifications@corebids.com&gt;<br />
        This mailbox isn't monitored. Please don't reply. Contact support via your dashboard.
      </p>
    </div>
  );
};

export default EmailStartDateSet;
// CB:END email-preview-start-date-set


